import { RequestError } from "@agentclientprotocol/sdk";
import {
  HttpResponseError,
  HttpUnauthorizedError,
  HttpForbiddenError,
} from "./http-errors";
import {
  CredentialsNotFoundError,
  CredentialsExpiredError,
} from "@pineseed/auth";

export function toRequestError(err: unknown): RequestError {
  if (
    err instanceof CredentialsNotFoundError ||
    err instanceof CredentialsExpiredError ||
    err instanceof HttpUnauthorizedError ||
    err instanceof HttpForbiddenError
  ) {
    return RequestError.authRequired(undefined, err.message);
  }
  if (err instanceof HttpResponseError) {
    return RequestError.internalError(undefined, err.message);
  }
  if (err instanceof Error) {
    return RequestError.internalError(undefined, err.message);
  }
  return RequestError.internalError(undefined, String(err));
}
